<section>
    <ng-container *ngIf="containers">
      <div
      (keydown.ArrowDown)="nextPage.emit()"
        class="sf-carousel"
        *ngFor="let container of containers; trackBy: trackById; let i = index"
        [attr.data-carouseli]="i"
        attr.data-carouselid="{{container.id}}"
      >
        <app-cards-carousel
        [containerToCenter]="'router-container'"
          [container]="container"
          [sponsor]="container?.sponsor?.enable ? container.sponsor : null"
          [verticalIndex]="i + initVerticalIndex"
          [carouselType]="carouselType(container)"
          [showPlayIcon]="showPlayIcon(container)"
          [showProgress]="showProgress(container)"
          [showTag]="container.type !== 'collection'"
        ></app-cards-carousel>
      </div>
    </ng-container>
  </section>